import { keyframes } from 'styled-components';

export const fadeIn = keyframes`
	0% { opacity: 0 }
	100% { opacity: 1 }
`;

export const fadeOut = keyframes`
	0% { opacity: 1 }
	100% { opacity: 0 }
`;

export const fadeInAndUp = keyframes`
	0% {
		opacity: 0;
		transform: translate3d(0, 10px, 0);
	}
	100% {
		opacity: 1;
		transform: translate3d(0, 0, 0);
	}
`;

export const fadeInAndRight = keyframes`
	0% {
		opacity: 0;
		transform: translate3d(-10px, 0, 0);
	}
	100% {
		opacity: 1;
		transform: translate3d(0, 0, 0);
	}
`;

export const fadeDownAndOut = keyframes`
	0% {
		opacity: 1;
		transform: translate3d(0, 0, 0);
	}
	100% {
		opacity: 0;
		transform: translate3d(0, 10px, 0);
	}
`;

export const pageEntry = keyframes`
	0% {
		opacity: 0;
		transform: translate3d(0, 20px, 0);
	}
	100% {
		opacity: 1;
		transform: translate3d(0, 0, 0);
	}
`;
